export default __webpack_public_path__ + "static/Plots0048-fba68d6f5e300a50b9f2b6cb33d51f99.jpg";